import { render, staticRenderFns } from "./pt-receiving-message.vue?vue&type=template&id=9427821e&"
import script from "./pt-receiving-message.vue?vue&type=script&lang=js&"
export * from "./pt-receiving-message.vue?vue&type=script&lang=js&"
import style0 from "./pt-receiving-message.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports